"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.subscribeToAccountPositionEvents = exports.selectPositionAndSave = exports.selectPosition = exports.requestingAccountPositions = exports.receivePositionsEvent = exports.receiveAccountPositions = exports.getAccountPositions = exports.SELECT_POSITION = exports.REQUEST_ACCOUNT_POSITIONS = exports.RECEIVE_POSITION_EVENT = exports.RECEIVE_ACCOUNT_POSITIONS = void 0;
var _apiActions = require("./apiActions");
var _actions = require("../margin/actions");
var _filterSortSupportedProducts = _interopRequireDefault(require("../../helpers/filterSortSupportedProducts"));
var _accountPositionSubscriptionService = _interopRequireDefault(require("../../services/subscriptions/accountPositionSubscriptionService"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var REQUEST_ACCOUNT_POSITIONS = exports.REQUEST_ACCOUNT_POSITIONS = 'REQUEST_ACCOUNT_POSITIONS';
var RECEIVE_ACCOUNT_POSITIONS = exports.RECEIVE_ACCOUNT_POSITIONS = 'RECEIVE_ACCOUNT_POSITIONS';
var RECEIVE_POSITION_EVENT = exports.RECEIVE_POSITION_EVENT = 'RECEIVE_POSITION_EVENT';
var SELECT_POSITION = exports.SELECT_POSITION = 'SELECT_POSITION';
var getAccountPositions = exports.getAccountPositions = function getAccountPositions(AccountId) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(dispatch, getState) {
      var OMSId, HideSmallAmounts, positions, filteredSortedPositions, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            _context.p = 0;
            dispatch(requestingAccountPositions);
            OMSId = getState().user.userInfo.OMSId;
            HideSmallAmounts = localStorage.getItem('hideMarginSmallAmounts') !== 'false';
            _context.n = 1;
            return dispatch((0, _apiActions.callAPI)('GetAccountPositions', {
              AccountId: AccountId,
              OMSId: OMSId,
              IncludePending: true,
              HideSmallAmounts: HideSmallAmounts
            }));
          case 1:
            positions = _context.v;
            if (!Array.isArray(positions)) {
              _context.n = 2;
              break;
            }
            filteredSortedPositions = (0, _filterSortSupportedProducts["default"])(positions);
            dispatch(receiveAccountPositions({
              AccountId: AccountId,
              data: filteredSortedPositions
            }));
            return _context.a(2, filteredSortedPositions);
          case 2:
            console.error('GetAccountPositions error: ', positions.errormsg);
          case 3:
            _context.n = 5;
            break;
          case 4:
            _context.p = 4;
            _t = _context.v;
            console.error('GetAccountPositions error: ', _t);
          case 5:
            return _context.a(2);
        }
      }, _callee, null, [[0, 4]]);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
var subscribeToAccountPositionEvents = exports.subscribeToAccountPositionEvents = function subscribeToAccountPositionEvents(AccountId) {
  var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : receivePositionsEvent;
  return function (dispatch) {
    _accountPositionSubscriptionService["default"].subscribe(function (update) {
      dispatch(callback(update));
      dispatch((0, _actions.getMaxTransferAmount)(update.ProductId));
    });
  };
};
var receivePositionsEvent = exports.receivePositionsEvent = function receivePositionsEvent(payload) {
  return {
    type: RECEIVE_POSITION_EVENT,
    payload: payload
  };
};
var requestingAccountPositions = exports.requestingAccountPositions = {
  type: REQUEST_ACCOUNT_POSITIONS,
  payload: {}
};
var receiveAccountPositions = exports.receiveAccountPositions = function receiveAccountPositions(payload) {
  return {
    type: RECEIVE_ACCOUNT_POSITIONS,
    payload: payload
  };
};
var selectPositionAndSave = exports.selectPositionAndSave = function selectPositionAndSave(payload) {
  return function (dispatch) {
    localStorage.setItem('selectedPositionId', payload);
    dispatch(selectPosition(payload));
  };
};
var selectPosition = exports.selectPosition = function selectPosition(payload) {
  return {
    type: SELECT_POSITION,
    payload: payload
  };
};